import React from 'react';

const ClockEditIcon = () => {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99977 9.51181H6.79024V5.88324H7.99977V9.51181ZM9.20929 1.6499H5.58072V2.85943H9.20929V1.6499ZM3.16167 8.90705C3.16178 7.87273 3.54082 6.87428 4.22714 6.10047C4.91346 5.32666 5.85949 4.83111 6.8864 4.70749C7.9133 4.58388 8.94992 4.84077 9.80027 5.4296C10.6506 6.01843 11.2558 6.89839 11.5013 7.90314L11.8642 7.54028C12.0577 7.34676 12.2936 7.21976 12.5355 7.15324C12.3403 6.55784 12.0391 6.00262 11.6465 5.51433L12.5052 4.65557C12.2331 4.34714 11.961 4.06895 11.6525 3.80285L10.7938 4.67371C9.85639 3.91171 8.6771 3.46419 7.39501 3.46419C5.95147 3.46419 4.56706 4.03763 3.54632 5.05836C2.52559 6.0791 1.95215 7.46351 1.95215 8.90705C1.95215 11.7071 4.06881 14.0112 6.79024 14.3136V13.092C4.7401 12.7957 3.16167 11.0419 3.16167 8.90705ZM7.99977 13.1162V14.3499H9.23348L12.9407 10.6488L11.707 9.409L7.99977 13.1162ZM13.9567 9.19128L13.1584 8.393C13.0374 8.27205 12.8379 8.27205 12.723 8.393L12.1303 8.98566L13.364 10.2194L13.9567 9.62671C14.0776 9.51181 14.0776 9.31224 13.9567 9.19128Z"
        fill="#888888"
      />
    </svg>
  );
};

export default ClockEditIcon;
